import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'pseic-form-field-errors',
  templateUrl: './pseic-form-field-errors.component.html',
  styleUrls: ['./pseic-form-field-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PseicFormFieldErrorsComponent implements AfterContentInit, OnDestroy {

  @Input() control: UntypedFormControl | UntypedFormArray;
  @Input() resizeOnError = true;
  @Input() multipleErrors = false;
  @Input() dataTestId: string = '';

  requiredField: string = $localize`:@@shared.required_field:To pole jest wymagane`;
  invalidEmail: string = $localize`:@@shared.invalid_email:Niepoprawny adres e-mail`;

  private subs = new Subscription();

  constructor(private cd: ChangeDetectorRef) {
  }

  ngAfterContentInit(): void {
    this.refreshOnChanges(this.control, this.cd);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private refreshOnChanges(formControl: UntypedFormControl | UntypedFormArray, cd: ChangeDetectorRef): void {
    if (formControl) {
      this.subs.add(
        formControl.statusChanges.subscribe(_ => cd.markForCheck())
      );
      this.subs.add(
        formControl.valueChanges.subscribe(_ => cd.markForCheck())
      )
    }
  }
}
